import { JSX } from 'react'

import type { AvatarRootProps, AvatarGroupProps } from '@chakra-ui/react'
import { Avatar, AvatarGroup } from '@chakra-ui/react'

import * as detective from '@/lib/detective.js'
import * as structure from '@/lib/structure.js'




// eslint-disable-next-line @typescript-eslint/naming-convention
export function Single
(
	props: AvatarRootProps
		& {
			alt?: string
			src?: string

		},

)
:	JSX.Element
{
	let src = ''

	if (detective.is_media_uri_string(props.src) )
	{
		src = props.src

	}

	return (
		<Avatar.Root {...structure.omit(props, 'src', 'alt')}>
			<Avatar.Fallback />

			<Avatar.Image src={src} alt={props.alt} />

		</Avatar.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Group (props: { src: string[] } & AvatarGroupProps): JSX.Element
{
	return (
		<AvatarGroup {...structure.omit(props, 'src')}>
			{props.src.map(v => <Single key={v} src={v} />)}

		</AvatarGroup>

	)

}
